var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleIcon = function SvgGoogleIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8832 6.82513H13.3999V6.80023H8.00017V9.20011H11.3909C10.8962 10.5971 9.56699 11.6 8.00017 11.6C6.01218 11.6 4.40036 9.98816 4.40036 8.00017C4.40036 6.01218 6.01218 4.40036 8.00017 4.40036C8.91782 4.40036 9.75268 4.74654 10.3883 5.31201L12.0854 3.615C11.0138 2.61636 9.58049 2.00049 8.00017 2.00049C4.68685 2.00049 2.00049 4.68685 2.00049 8.00017C2.00049 11.3135 4.68685 13.9999 8.00017 13.9999C11.3135 13.9999 13.9999 11.3135 13.9999 8.00017C13.9999 7.59789 13.9585 7.20521 13.8832 6.82513Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.69287 5.20762L4.66407 6.65324C5.19744 5.33271 6.48917 4.40036 8.00079 4.40036C8.91844 4.40036 9.7533 4.74654 10.389 5.31201L12.086 3.615C11.0144 2.61636 9.58111 2.00049 8.00079 2.00049C5.69631 2.00049 3.69782 3.30152 2.69287 5.20762Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.99991 13.9999C9.54963 13.9999 10.9578 13.4068 12.0224 12.4423L10.1655 10.871C9.54289 11.3445 8.7821 11.6006 7.99991 11.6C6.43939 11.6 5.11436 10.6049 4.61519 9.21631L2.65869 10.7237C3.65164 12.6667 5.66813 13.9999 7.99991 13.9999Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.883 6.82519H13.3997V6.80029H8V9.20017H11.3907C11.1541 9.86506 10.7279 10.4461 10.1647 10.8714L10.1656 10.8708L12.0225 12.4421C11.8911 12.5615 13.9997 11.0001 13.9997 8.00023C13.9997 7.59795 13.9583 7.20527 13.883 6.82519Z",
    fill: "#1976D2"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "google-icon.610d92ae41b0e9654fb99f85a0e0a49a.svg";